import { createContext, useContext, useState } from "react"
import Snackbar, { ESnackbarTypes, TSnackbarProps } from "./Snackbar"
import Transition from "../Transition/Transition"

export type TSnackbarContext = {
    addSnackbar:(title:any, msg?:string, type?:ESnackbarTypes, duration?:number) => void
}

const SnackbarContext = createContext<TSnackbarContext>({} as any)
export const useSnackbar = () => useContext(SnackbarContext)

var g_id = 0
export default function SnackbarProvider(props:{children:JSX.Element}) {
    const [snackbars,setSnackbars] = useState<TSnackbarProps[]>([])
    const [show,setShow] = useState<boolean>(false)

    const addSnackbar = (title:any, msg?:string, type:ESnackbarTypes="error", duration?:number) => {
        const id = `snack_${g_id++}`
        const timeout = duration ?? type=="error" ? 5000 : 3000
        setSnackbars(snackbars => [...snackbars,{id,title,msg:msg||"",type,duration:timeout}])
        setShow(true)
    }
    const onDismiss = () => setSnackbars([])
    const onDismissed = () => setShow(false)
    const snackbar = snackbars.length ? <Snackbar {...snackbars[0]} onDismiss={onDismiss}/> : null
    const transition = show ? <Transition className="snackbar" transition="slideDown" afterLeaving={onDismissed}>{snackbar}</Transition> : null
    return <SnackbarContext.Provider value={{addSnackbar}}>
        {props.children}
        {transition}
    </SnackbarContext.Provider>
}